var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { DishOptionSetList } from '../elements/dish.option-set-list';
import { DishIngredientsList } from '../elements/dish.ingredients-list';
import { DishComboChoiceList } from '../elements/dish.combo-list';
import Big from 'big.js';
import { SortType } from '@lib/common';
let OrderBumpItemsClass = class OrderBumpItemsClass extends React.Component {
    render() {
        const { t } = this.props;
        const { items, itemContent, isPrinting } = this.props;
        const details = this.props.renderDetails || {
            enabled: true,
            prices: true,
            option_prices: true,
            combo_choice_names: true,
            sort_type: SortType.ByCart.toString(),
        };
        if (!details.enabled) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-left" },
                items.subtitle && React.createElement("p", { className: "small lh14" }, items.subtitle),
                items.type !== 'combo' && (React.createElement("div", null,
                    (items.option_sets || []).length > 0 && (React.createElement("div", { className: "m-t-1" },
                        React.createElement(DishOptionSetList, { option_sets: items.option_sets, renderDetails: details, isPrinting: isPrinting, isBumpScreen: true }))),
                    (items.ingredients || []).length > 0 && (React.createElement("div", { className: "m-t-1" },
                        React.createElement(DishIngredientsList, { ingredients: items.ingredients }))))),
                items.type === 'combo' && (React.createElement("div", { className: "m-t-1" },
                    React.createElement(DishComboChoiceList, { choices: items.choices, renderDetails: details, isBumpScreen: true }))),
                items.notes && (React.createElement("p", { className: "m-t-1 small" },
                    t('order.receipt.dishes.notes'),
                    ": ",
                    items.notes))),
            details.prices && (React.createElement("div", null,
                typeof items.discount === 'number' && items.discount > 0 && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "small" },
                        React.createElement("s", null, t('currency', { value: items.price }))),
                    React.createElement("p", null, t('currency', { value: Big(items.price).minus(items.discount).toFixed(2) })))),
                typeof items.discount === 'undefined' && (React.createElement("p", null, items.price !== 0 ? t('currency', { value: items.price }) : 'Free'))))));
    }
};
OrderBumpItemsClass = __decorate([
    observer
], OrderBumpItemsClass);
export const OrderBumpItems = withTranslation()(OrderBumpItemsClass);
//# sourceMappingURL=order-bump-items.js.map